<template>
  <div>
    <div class="vld-parent">
      <Loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    </div>
    <div class="page-header">
      <h3>Trash</h3>
    </div>

    <ul class="mt-2 list-group">
      <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
        <QuickTask :task="task" />
      </li>
    </ul>
  </div>
</template>

<script>

import api from "api";
import QuickTask from "components/QuickTask";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    QuickTask,
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      allTasks: []
    }
  },
  created() {
    this.isLoading = true;
    return api.getTrash().then(response => {
      this.isLoading = false
      this.allTasks = response.data;
    });
  },
  methods: {
    restoreTask(task){
      api.restoreTask(task.id).then(response => {
        var index = this.allTasks.findIndex(t => t.id === task.id);
        this.allTasks.splice(index, 1);
      });
    }
  }
};
</script>
